/*
 * @Author: hai.yang3 hai.yang3@gientech.com
 * @Date: 2022-08-18 17:24:08
 * @LastEditors: luxiao.guo luxiao.guo@gienteck.com
 * @LastEditTime: 2022-11-21 17:23:30
 * @FilePath: \unified-development-platform\src\apis\auth\move-auth\role_manage_api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { request } from '@/apis/request';
const PRE_PATH = '/v1/app';
/**
 * @description: 角色管理 —— 分页查询接口
 * @param {*} params
 * @return {*}
 */
export const get_role_list = params => {
  return request({
    url: `${PRE_PATH}/appRole/page`,
    method: 'get',
    params: params,
  });
};
/**
 * @description: 角色管理 —— 删除
 * @param {*} roleNo
 * @param {*} appId
 * @return {*}
 */
export const delete_role = (roleNo, appId) => {
  return request({
    url: `${PRE_PATH}/appRole/delete?no=${roleNo}&appId=${appId}`,
    method: 'delete',
    rd: true,
  });
};

/**
 * @description: 角色管理 —— 获取角色下的用户
 * @param {*} params
 * @return {*}
 */
export const get_related_users = params => {
  return request({
    url: `${PRE_PATH}/appUser/queryByRole`,
    method: 'get',
    params: params,
    rd: true,
  });
};
/**
 * @description: 角色管理 —— 为角色添加用户
 * @param {*} params
 * @return {*}
 */
export const relate_users = params => {
  return request({
    url: `${PRE_PATH}/appRole/assignRole`,
    method: 'post',
    data: params,
    rd: true,
  });
};
/**
 * @description: 角色管理 —— 新增或修改
 * @param {*} params
 * @return {*}
 */
export const update_role = params => {
  return request({
    url: `${PRE_PATH}/appRole/save`,
    method: 'post',
    data: params,
    rd: true,
  });
};
/**
 * @description: 角色管理 —— 获取详情
 * @param {*} roleNo
 * @param {*} appId
 * @return {*}
 */
export const get_role_detail = params => {
  return request({
    url: `${PRE_PATH}/appRole/detail`,
    method: 'get',
    params,
    rd: true,
  });
};
/**
 * @description: 角色管理 —— 查询所有角色（不分页）
 * @param {*} params
 * @return {*}
 */
export const get_enable_roles = params => {
  return request({
    url: `${PRE_PATH}/appRole/all`,
    method: 'get',
    params: params,
    rd: true,
  });
};
/**
 * @description: 角色管理 —— 判断角色是否存在
 * @param {*} roleName
 * @param {*} appId
 * @return {*}
 */
export const check_role_name = (roleName, appId) => {
  return `${PRE_PATH}/appRole/roleName?appId=${appId}&roleName=${roleName}`;
};

/**
 * @description: 角色管理 —— 创建角色时，关联菜单时获取所有菜单
 * @param {*} appId
 * @return {*}
 */
export const get_role_menus = appId => {
  return request({
    url: `${PRE_PATH}/menu/roleMenus?appId=${appId}`,
    method: 'get',
    rd: true,
  });
};

/**
 * @description: 角色管理 —— 获取角色扩展字段
 * @return {*}
 */
export const queryRoleExtendFiled = params => {
  return request({
    url: `${PRE_PATH}/appRole/extendFiled`,
    method: 'post',
    params,
    rd: true,
  });
};
